import { render, staticRenderFns } from "./PostsWaitingForApproval.vue?vue&type=template&id=a780edda"
import script from "./PostsWaitingForApproval.vue?vue&type=script&lang=js"
export * from "./PostsWaitingForApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports